/** Runs before paint; React hydrates a deterministic theme then restores preferences. */
export const THEME_BOOTSTRAP_SCRIPT = `try {
  var root = document.documentElement;
  var t = localStorage.getItem("glider:webapp-v2:theme");
  var dark = t === "dark" || (t !== "light" && matchMedia("(prefers-color-scheme: dark)").matches);
  root.classList.remove("light", "dark");
  root.classList.add(dark ? "dark" : "light");
  root.style.colorScheme = dark ? "dark" : "light";
} catch {}`;
